var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPeriwinkle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 115,
    height: 109,
    viewBox: "0 0 115 109",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.60002,
    d: "M25.624 20.7197C21.3483 -2.4249 53.0683 -13.3628 63.9669 7.49803C68.7446 16.6429 78.9269 21.6035 89.0729 19.7292C112.218 15.4535 123.155 47.1736 102.295 58.0722C93.1497 62.8498 88.1891 73.0321 90.0634 83.1781C94.3391 106.323 62.6191 117.261 51.7205 96.3998C46.9428 87.2549 36.7605 82.2943 26.6145 84.1687C3.46987 88.4443 -7.46803 56.7243 13.3928 45.8257C22.5377 41.048 27.4983 30.8657 25.624 20.7197Z",
    fill: "#00D092",
    stroke: "#111111",
    strokeWidth: 3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeriwinkle);
export default __webpack_public_path__ + "static/media/Periwinkle.1b59cb26c10171d6b91d84058f83f368.svg";
export { ForwardRef as ReactComponent };